<template>
  <div class="label-chatrs">
		<div class="">
			<span class="clabels-text font-12 inline-block txt-dark capitalize-font pull-left"><span class="block font-15 weight-500 mb-5">{{$t(`app.dashboard.${currentKey}`)}}</span><span class="block txt-grey">{{count + ' ' + $t(suffix)}}</span></span>
			<div class="pull-right"><span class="font-18">{{Math.round(count / (allCount === 0 ? 1 : allCount) * 100) + '%'}}</span></div>
			<div class="clearfix"></div>
		</div>
		<hr v-if="currentKey !== lastKey" class="light-grey-hr row mt-10 mb-15">
	</div>
</template>
<script>

export default {
  name: "PercentCard",
  components: {
  },
  props: {
		count: {
			type: Number,
			default: 0,
		},
		allCount: {
			type: Number,
			default: 0,
		},
		currentKey: {
			type: String,
			required: true,
		},
		lastKey: {
			type: String,
			required: true,
		},
		suffix: {
			type: String,
			required: true,
		}
	},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
	}
};
</script>

<style lang="scss" scopred>
.label-chatrs .clabels-text span:first-child {
  line-height: 5.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/PercentCard.vue